import { NUMBERS } from '../constants/regExp';

export const getIsValidScan = (result: string) => NUMBERS.test(result);
